import React, { PropsWithChildren, ReactElement, ReactNode } from "react";
import ReactDOM from "react-dom";

interface DraggablePortalItemParams {
  snapshot: any;
}

export function DraggablePortalItem(
  props: PropsWithChildren<DraggablePortalItemParams>,
): React.ReactElement<any, string | React.JSXElementConstructor<any>> {
  const usePortal: boolean = props.snapshot.isDragging;

  const child: ReactNode = <>{props.children}</>;

  if (!usePortal) {
    return child;
  }

  // if dragging - put the item in a portal
  return ReactDOM.createPortal(child, document.body) as ReactElement<any, string>;
}
